/* P88 — turns the PDP info <details> (.p88-info__d: Shipping & Returns / Care / Design) into a
   horizontal tab bar with a fixed panel below, so opening one never moves the headings. Builds
   from existing markup; idempotent; re-runs on DOM changes for soft navigations. */
(function(){
  function buildTabs(info){
    if(info.dataset.p88Tabs==='1'){ return; }
    var items=[].slice.call(info.querySelectorAll('.p88-info__d'));
    if(!items.length){ return; }
    info.dataset.p88Tabs='1';
    var bar=document.createElement('div'); bar.className='p88-tabs__bar'; bar.setAttribute('role','tablist');
    var panel=document.createElement('div'); panel.className='p88-tabs__panel';
    items.forEach(function(d,i){
      var sum=d.querySelector('summary');
      var title=sum?sum.textContent.trim():('Section '+(i+1));
      var content=d.querySelector('.p88-info__c');
      var btn=document.createElement('button');
      btn.type='button'; btn.className='p88-tabs__tab'; btn.textContent=title; btn.setAttribute('role','tab');
      btn.addEventListener('click',function(){
        var tabs=bar.querySelectorAll('.p88-tabs__tab');
        for(var k=0;k<tabs.length;k++){ tabs[k].setAttribute('aria-selected','false'); }
        btn.setAttribute('aria-selected','true');
        panel.innerHTML='';
        if(content){ var c=content.cloneNode(true); c.style.display='block'; panel.appendChild(c); }
      });
      bar.appendChild(btn);
    });
    info.appendChild(bar); info.appendChild(panel);
    info.classList.add('p88-has-tabs');
    var first=bar.querySelector('.p88-tabs__tab'); if(first){ first.click(); }
  }
  function run(){ var list=document.querySelectorAll('.p88-info'); for(var i=0;i<list.length;i++){ buildTabs(list[i]); } }
  var scheduled=false;
  function schedule(){ if(scheduled){ return; } scheduled=true; var raf=window.requestAnimationFrame||window.setTimeout; raf(function(){ scheduled=false; run(); }); }
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded',run); } else { run(); }
  try{ var mo=new MutationObserver(function(){ schedule(); }); mo.observe(document.documentElement,{childList:true,subtree:true}); }catch(e){}
})();
